<template>
  <Login>
    <template v-slot:title>
      <span id="loginTitle">{{ $t("Hello") }}!</span>
      <span id="loginMessage">{{ $t("LetsStartWorking") }}</span>
    </template>
    <template v-slot:form>
      <form class="loginForm">
        <div class="main-login-form-container">
          <div class="email-div" v-if="!keyIsNecessary">
            <span class="login-input-label">{{ $t('Email') }}</span>
            <input
              v-model="email"
              ref="email"
              type="email"
              name="email"
              class="loginInput userInput effect-7"
              spellcheck="false"
              @keyup.enter="loginSubmit"
              :class="{ fieldErrorInput: badEmail }"
            />
          </div>

          <div class="password-div" v-if="!keyIsNecessary">
            <span class="login-input-label">{{ $t('Password') }}</span>
            <input
              v-model="password"
              :type="type"
              name="pass"
              class="loginInput passwordInput effect-7"
              :class="{ fieldErrorInput: badPassword }"
              @keyup.enter="loginSubmit"
            />
            <v-icon @click="showPassword" class="password-icon">{{
              type != "password" ? " mdi-eye-off" : "mdi-eye"
            }}</v-icon>
          </div>

          <div class="twofa-div" v-if="keyIsNecessary">
            <span class="login-input-label">{{ $t('TwoFactorAuthenticationKey') }}</span>
            <input
              v-model="key"
              type="text"
              name="key"
              class="loginInput twoFaInput effect-7"
              @keyup.enter="loginSubmit"
              :class="{ fieldErrorInput: badKey }"
            />
          </div>
        </div>
      </form>
    </template>
    <template v-slot:button>
      <v-btn
        type="submit"
        :loading="loading"
        :disabled="submitButtonDisable"
        color="accent--text"
        @click="loginSubmit"
        class="signInInput"
        outlined
      >
        {{ !keyIsNecessary ? $t("Login") : $t("Continue") }}
      </v-btn>
    </template>
    <template v-slot:remember-me-reset-password>
      <div class="field-error-div" v-show="!keyIsNecessary">
        <span v-if="badPassword">
          {{ $t("InvalidCredentials") }}
        </span>
        <span v-if="noCompany">
          {{ $t("NoCompanyAssociated") }}
        </span>
        <span v-if="userInactive">
          {{ $t("UserInactive") }}
        </span>
        <span v-if="companyInactive">
          {{ $t("CompanyInactive") }}
        </span>
      </div>
      <div v-if="badKey" class="field-error-div">
        <span>
          {{ $t("Keyisinvalid") }}
        </span>
      </div>
      <div v-if="!keyIsNecessary" class="passwordRecoveryDiv">
        <InputField
              inputType="checkbox"
              :value="savePassword"
              :checkbox-options=checkboxOptions
              @input="handleCheckboxChange()"
              :height=16
              :width=16
              :border="'0px'"
              :checkboxLabelStyle='checkboxLabelStyle'
              :size="'50'"
              :inputStyle="inputStyle"
            />
        <a @click="forgotHandler" class="forgotPasswordLink"
          >{{ $t("ForgotPassword") }}</a
        >
    </div>
    </template>
  </Login>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Login from "../../views/Login.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";

export default {
  name: "LoginPage",

  components: { Login, InputField },

  data() {
    return {
      email: "",
      password: "",
      badPassword: false,
      noCompany: false,
      userInactive: false,
      companyInactive: false,
      savePassword: false,
      loading: false,
      key: null,
      badKey: false,
      badEmail: false,
      type: "password",
      keyIsNecessary: false,
      checkboxOptions:[
        {
          id:1,
          label:this.$t("RememberMe")
        }
      ],
      checkboxLabelStyle: {
        'font-size': '16px',
        'color': '#231E46',
        'font': 'Lato',
      },
      inputStyle: {
        'border': '0px'
      }
    };
  },

  computed: {
    ...mapState(["loggingIn", "loginError", "companies"]),

    /* loginSuccessful () {
        console.log(this.loginSuccessful)
        if(this.loginSuccessful) {
          this.$router.push({ name: 'login-company' })
        }
      }*/
    submitButtonDisable() {
      return this.email === "" || this.password === "";
    },
  },

  mounted() {
    this.focusInput();

    const token = new URLSearchParams(window.location.search).get("token");

    if (token) {
      localStorage.setItem("auth_token", token);
      this.fetchUserDetails().then(() => {
        window.location.href = "/";
      });
    }
  },

  methods: {
    ...mapActions([
      "LOGIN_REQUEST",
      "GET_USER_COMPANIES",
      "PICK_COMPANY",
      "LOGOUT",
      "getUserPreference",
      "changeUserPreference",
      "fetchUserDetails"
    ]),

    handleCheckboxChange(){
      this.savePassword = !this.savePassword
    },

    forgotHandler() {
      this.$router.push({name: "login-recovery-email"})
    },

    loginSubmit() {
      this.badPassword = false;
      this.badKey = false;
      this.badEmail = false;
      this.noCompany = false;
      this.companyInactive = false;
      this.userInactive = false;
      this.loading = true;
      let dataToSend = {
        email: this.email.toLowerCase(),
        password: this.password,
      };
      if (this.key) {
        dataToSend.key_2fa = this.key;
      }
      this.LOGIN_REQUEST(dataToSend)
        .then(() => {
          this.$router.push({ name: "hub" });
        })
        .catch((error) => {
          this.handleError(error);
          console.error(error);
          this.loading = false;
        });
        try {
          const userID = parseInt(this.$store.getters.currentUserID);
          const userData = { user_id:  userID };
          const userPreferences = this.getUserPreference(userData);
          let dataToChange = {};

          if(userPreferences.language){
            localStorage.setItem("lang",userPreferences.language);
          } else {
            let localLanguage = localStorage.getItem("lang");
            if(!localLanguage){
              localLanguage = "en_uk";
              localStorage.setItem("lang","en_uk");
            }
            dataToChange.language = localLanguage;
          }

          if(userPreferences.measurement_system){
            localStorage.setItem("measureSystem",userPreferences.measurement_system);
          } else {
            let localMeasureSystem = localStorage.getItem("measureSystem");
            if(!localMeasureSystem){
              localMeasureSystem = "metric";
              localStorage.setItem("measureSystem","metric");
            }
            dataToChange.measurement_system = localMeasureSystem;
          }
          if(Object.keys(dataToChange).length){
            dataToChange.user_id = userID;
            this.changeUserPreference(dataToChange);
            localStorage.setItem("lang","en_uk");
            dataToChange = {user_id:  userID, language: "en_uk" };
            this.setUserPreference(data);
          }
        }catch (e) {
          this.handleError(error);
          console.error(error);
        }
    },

    getCompanies() {
      this.GET_USER_COMPANIES()
        .then((companies) => {
          if (companies.length > 1) {
            this.$router.push({ name: "login-company" });
          } else if (companies.length === 1) {
            this.pickCompany(companies);
          } else if (companies.length === 0) {
            localStorage.removeItem("auth_token");
            this.noCompany = true;
          } else {
            console.log("an error occured");
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .then(() => {
          this.loading = false;
        });
    },

    pickCompany(resp) {
      this.$router.push({ name: "hub" }).catch((err) => {
        // Ignore the vue err regarding  navigating to the page they are already on.
        if (err.name !== "NavigationDuplicated") {
          // But print any other errors to the console
          console.error(err);
        }
      });
    },

    handleError(error) {
      let data = error.response ? error.response.data : null;
      let code = data ? data.status_code : null;
      switch (code) {
        case 401: {
          if (data.message.includes("Invalid Credentials")) {
            this.badPassword = true;
            this.badEmail = true;
            this.$toasted.global.toast_error(this.$t("CheckEmailPassword"));
          }
          if (data.message.includes("Key is invalid")) {
            this.badKey = true;
          }
          if (
            data.message.includes(
              "Enter the verification code generated by the authenticator application"
            )
          ) {
            this.keyIsNecessary = true;
          }
          if (data.message.includes("Company inactive")) {
            this.companyInactive = true;
          }
          if (data.message.includes("inactive")) {
            this.userInactive = true;
          }
          break;
        }

        default: {
          this.$toasted.global.toast_error(
            "An error occurred. Please try again later."
          );
          break;
        }
      }
    },

    focusInput() {
      this.$refs.email.focus();
    },

    showPassword() {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
  },
};
</script>

<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #32383d inset !important;
  -webkit-transition-delay: 99999s;
  caret-color: var(--secondary-lighter);
}

.field-error-div {
  text-align: left;
  position: relative !important;
  font-size: 16px !important;
  color: var(--red);
  bottom: unset;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px !important;
}

.remember-me-input .theme--light.v-icon {
  color: #231E46;
}

.two-factor-authentication-title {
  color: #d7d5d5;
  text-align: center;
  padding: 20px 15px;
  font-size: 13px;
}
.password-icon {
  color: #231E46 !important;
  position: absolute !important;
  bottom: 31px;
  right: 12px;
  z-index: 2;
}

.fieldErrorInput {
  border: 1px solid var(--red);
}

input:invalid {
  border-bottom: 1px solid transparent;
}

.loginInput:active,
.loginInput:focus {
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginPage.vue